import React from 'react';
import PropTypes from 'prop-types';
import cn from '../../../utils/cn';

import styles from './Tag.module.scss';

function Tag({
  label, icon, color, secondaryColor, theme, className, children,
}) {
  return (
    <div
      className={cn([
        styles.tag,
        'd-inline-flex center ws-nowrap font-secondary fs-14 fw-500',
        className || '',
        theme ? styles[theme] : '',
      ])}
      style={color && secondaryColor ? { backgroundColor: color, color: secondaryColor } : {}}
    >
      {icon ? (
        <span
          className={cn([
            'd-flex center',
            label ? 'm-r-10' : '',
          ])}
        >
          {icon}
        </span>
      ) : null}

      {label || children}
    </div>
  );
}

Tag.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.any)]),
  icon: PropTypes.node,
  color: PropTypes.string,
  secondaryColor: PropTypes.string,
  theme: PropTypes.oneOf([
    'primary',
    'green',
    'red',
    'grey',
    'yellow',
  ]),
  className: PropTypes.string,
  children: PropTypes.node,
};

Tag.defaultProps = {
  label: null,
  icon: null,
  color: null,
  secondaryColor: null,
  theme: null,
  className: null,
  children: null,
};

export default Tag;
